import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) { setLoading(false); return; }
    try { const { data } = await api.get("/admin/me"); setAdmin(data); }
    catch { localStorage.removeItem("admin_token"); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem("admin_token", data.token);
    setAdmin(data.user);
    return data.user;
  };
  const logout = () => { localStorage.removeItem("admin_token"); setAdmin(null); };

  return <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>{children}</AdminAuthContext.Provider>;
}
